import speed_icon from "@/assets/icons/map/speed.svg"
import route_icon from "@/assets/icons/map/route.svg"
import temperature_icon from "@/assets/icons/map/temperature.svg"
import signal_icon from "@/assets/icons/map/signal.svg"
import battery_icon from "@/assets/icons/map/battery.svg"
import fuel_icon from "@/assets/icons/map/fuel.svg"

export const options = [
  {
    label: "35 MPH",
    icon: speed_icon
  },
  {
    label: "1625 miles",
    icon: route_icon
  },
  {
    label: "78°C",
    icon: temperature_icon
  },
  {
    label: "9 signals",
    icon: signal_icon
  },
  {
    label: "80%",
    icon: battery_icon
  },
  {
    label: "48%",
    icon: fuel_icon
  }
]

export const modalStyles = {
  xs: {
    container: {
      paddingX: "4px",
      bottom: "55%",
      borderRadius: "2px"
    },
    header: {
      marginBottom: "5px",
      paddingTop: "4px"
    },
    circle: {
      width: "3px",
      height: "3px",
      borderRadius: "3px",
      marginRight: "3px"
    },
    headerLabel: {
      fontSize: "0.4rem !important"
    },
    closeIcon: {
      fontSize: "6px"
    },
    description: {
      padding: "3px 5px",
      borderRadius: "2px",
      marginBottom: "5px"
    },
    descriptionLabel: {
      fontSize: "0.2rem !important"
    },
    updateLabel: {
      fontSize: "0.2rem !important",
      marginRight: "2px"
    },
    reloadIconContainer: {
      borderRadius: "1px",
      border: "0.5px solid #CCCCCC",
      minWidth: "6px",
      height: "6px"
    },
    reloadIcon: {
      width: "4px",
      height: "4px"
    },
    grid: {
      paddingBottom: "4px"
    },
    gridItemIcon: {
      width: "7px",
      height: "7px"
    },
    gridItemLabel: {
      fontSize: "0.1575rem !important"
    },
    gridItemBatteryContainer: {
      border: "2px",
      padding: "3px 5px"
    },
    gridItemBatteryIcon: {
      width: "7px",
      height: "7px"
    },
    gridItemBatteryLabel: {
      fontSize: "0.15rem !important",
      marginX: "1px"
    },
    gridItemBatteryLabelPercentages: {
      fontSize: "0.25rem !important"
    }
  },
  lg: {
    container: {
      paddingX: "7px",
      bottom: "50%",
      borderRadius: "3px"
    },
    header: {
      marginBottom: "8.5px",
      paddingTop: "8px"
    },
    circle: {
      width: "5px",
      height: "5px",
      borderRadius: "5px",
      marginRight: "5.5px"
    },
    headerLabel: {
      fontSize: "0.5rem !important"
    },
    closeIcon: {
      fontSize: "11px"
    },
    description: {
      padding: "7px 8px",
      borderRadius: "2.5px",
      marginBottom: "8px"
    },
    descriptionLabel: {
      fontSize: "0.35rem !important"
    },
    updateLabel: {
      fontSize: "0.35rem !important",
      marginRight: "3.5px"
    },
    reloadIconContainer: {
      borderRadius: "2px",
      border: "1px solid #CCCCCC",
      minWidth: "10px",
      height: "10px"
    },
    reloadIcon: {
      width: "8px",
      height: "8px"
    },
    grid: {
      paddingBottom: "8px"
    },
    gridItemIcon: {
      width: "11px",
      height: "11px"
    },
    gridItemLabel: {
      fontSize: "0.3rem !important"
    },
    gridItemBatteryContainer: {
      border: "3px",
      padding: "5px 7px"
    },
    gridItemBatteryIcon: {
      width: "12px",
      height: "12px"
    },
    gridItemBatteryLabel: {
      fontSize: "0.3rem !important",
      marginX: "3px"
    },
    gridItemBatteryLabelPercentages: {
      fontSize: "0.4rem !important"
    }
  },
  xl: {
    container: {
      paddingX: "10px",
      bottom: "60%",
      borderRadius: "3px"
    },
    header: {
      marginBottom: "10px",
      paddingTop: "10px"
    },
    circle: {
      width: "5px",
      height: "5px",
      borderRadius: "5px",
      marginRight: "6px"
    },
    headerLabel: {
      fontSize: "0.625rem !important"
    },
    closeIcon: {
      fontSize: "15px"
    },
    description: {
      padding: "10px 12px",
      borderRadius: "3px",
      marginBottom: "10px"
    },
    descriptionLabel: {
      fontSize: "0.5rem !important"
    },
    updateLabel: {
      fontSize: "0.5rem !important",
      marginRight: "5px"
    },
    reloadIconContainer: {
      borderRadius: "2px",
      border: "1px solid #CCCCCC",
      minWidth: "16px",
      height: "16px"
    },
    reloadIcon: {
      width: "10px",
      height: "10px"
    },
    grid: {
      paddingBottom: "10px"
    },
    gridItemIcon: {
      width: "15px",
      height: "15px"
    },
    gridItemLabel: {
      fontSize: "0.4375rem !important"
    },
    gridItemBatteryContainer: {
      border: "3px",
      padding: "7px 10px"
    },
    gridItemBatteryIcon: {
      width: "15px",
      height: "15px"
    },
    gridItemBatteryLabel: {
      fontSize: "0.4375rem !important",
      marginX: "5px"
    },
    gridItemBatteryLabelPercentages: {
      fontSize: "0.625rem !important"
    }
  }
}